import React from "react";
import { Box, Typography } from "@mui/material";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";

interface EmptyAddCardProps {
  onAdd: () => void;
  title: string;
  description: string;
}

export const EmptyAddCard: React.FC<EmptyAddCardProps> = ({ onAdd, title, description }) => (
  <Box
    sx={{
      mt: "20px",
      display: "flex",
      justifyContent: "center",
    }}
  >
    <Box
      onClick={onAdd}
      sx={{
        width: 380,
        height: 220,
        backgroundColor: "background.default",
        border: "2px dashed",
        borderColor: "primary.main",
        borderRadius: 3,
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        cursor: "pointer",
        gap: 1.2,
        transition: "all 0.3s ease",
        "&:hover": {
          backgroundColor: "rgba(0, 94, 255, 0.05)",
          transform: "scale(1.02)",
        },
      }}
    >
      <AddCircleOutlineIcon sx={{ color: "primary.main", fontSize: 30 }} />

      <Typography
        sx={{
          fontWeight: 600,
          fontSize: 16,
          color: "text.primary",
        }}
      >
        {title}
      </Typography>

      <Typography
        sx={{
          fontSize: 13,
          color: "grey.primary",
        }}
      >
        {description}
      </Typography>
    </Box>
  </Box>
);
